// extracted by css-extract-rspack-plugin
export default {"header":"_da1f2ee1","message":"_3bb7ffd5","inputWrapper":"_f6adaf9b","loginAgainCta":"_8bb6786b"};